import React, { ReactElement, useEffect, useState, ReactNode } from 'react';
import { Paper } from '@mui/material';

import { RoundedCTAPaper } from '../../globals/styles';
export interface Props {
    Icon: ReactElement | ReactNode;
    text: string;
    link: string;
    newTab?: boolean;
}

export default function RoundedCTA({Icon,text,link,newTab=false}:Props) {

    return <a href={link} target={newTab ? "_blank" : ""} className="hoverme">
        <RoundedCTAPaper elevation={5}>
            {Icon}
            <h4 style={{fontSize: "1.25rem", padding: 0, margin: 0}}>{text}</h4>
        </RoundedCTAPaper>
    </a>
}